var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"Logo",attrs:{"src":require('@theme/assets/img/logo.png'),"height":"53"}})
}
var staticRenderFns = []

export { render, staticRenderFns }